import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { PaymentPreviewV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const PoiPadResultComponentPaymentPreviewActions = createActionGroup({
  source: 'Pad Result Component Payment Preview',
  events: {
    'Load Payment Preview Success': props<{
      payload: PaymentPreviewV1Response;
    }>(),
    'Load Payment Preview Error': props<{ error: HttpErrorResponse }>(),
  },
});
